import { Check, Fingerprint, Info, Loader2, Lock, Search, Shield, ShieldCheck } from 'lucide-react';
import Header from '../layout/Header';

const sources = [
  { name: 'VirusTotal', desc: '72 moteurs vérifiés', icon: ShieldCheck },
  { name: 'Google Safe Browsing', desc: 'Base mondiale de menaces', icon: Search },
  { name: 'URLScan.io', desc: 'Analyse visuelle du site', icon: Shield },
  { name: 'WHOIS', desc: 'Informations du domaine', icon: Fingerprint },
];

function SourceRow({ source, index, currentStep }) {
  const Icon = source.icon;
  const done = index < currentStep;
  const active = index === currentStep;

  return (
    <div
      className={`card flex items-center gap-4 min-h-[88px] opacity-0 ${active ? 'border-accent-blue/40 ring-2 ring-accent-blue/20' : ''}`}
      style={{ animation: `fadeUp 450ms ease ${index * 180}ms forwards` }}
    >
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${done ? 'bg-verdict-safe-bg' : active ? 'bg-accent-blue/10' : 'bg-gray-100'}`}>
        <Icon className={`w-6 h-6 ${done ? 'text-verdict-safe' : active ? 'text-accent-blue' : 'text-text-subtle'}`} />
      </div>
      <div className="flex-1 min-w-0">
        <p className={`font-bold ${active ? 'text-accent-blue' : done ? 'text-text-primary' : 'text-text-muted'}`}>{source.name}</p>
        <p className="text-sm text-text-muted leading-snug">{active ? 'Vérification en cours...' : source.desc}</p>
      </div>
      {done ? (
        <span className="w-8 h-8 rounded-full border-2 border-verdict-safe text-verdict-safe flex items-center justify-center">
          <Check className="w-5 h-5" />
        </span>
      ) : active ? (
        <Loader2 className="w-8 h-8 text-accent-blue animate-spin" />
      ) : (
        <span className="w-8 h-8 rounded-full border-2 border-gray-300" />
      )}
    </div>
  );
}

export default function LoadingSpinner({ url = '', currentStep = 1 }) {
  const step = Math.max(0, Math.min(3, currentStep));

  return (
    <div className="page-container">
      <Header />
      <div className="px-4 pt-10 flex flex-col items-center">
        <div className="relative w-36 h-36 flex items-center justify-center">
          <div className="absolute inset-0 rounded-full border-[10px] border-gray-200 border-t-accent-blue animate-spin" />
          <Shield className="w-16 h-16 text-brand-navy" strokeWidth={2.4} />
        </div>
        <h1 className="mt-6 text-xl font-semibold text-text-primary">Analyse en cours...</h1>
        <p className="mt-4 max-w-full bg-gray-100 rounded-xl px-4 py-3 font-mono text-sm text-accent-blue truncate">
          {url || 'Préparation de l’analyse'}
        </p>

        <div className="w-full mt-8">
          <div className="flex items-center justify-between mb-3">
            <p className="text-text-muted font-medium">Progression globale</p>
            <p className="text-accent-blue font-bold">75%</p>
          </div>
          <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-accent-blue rounded-full" style={{ animation: 'fillProgress 5s linear forwards' }} />
          </div>
        </div>

        <div className="w-full mt-8 space-y-4">
          {sources.map((source, index) => (
            <SourceRow key={source.name} source={source} index={index} currentStep={step} />
          ))}
        </div>

        <div className="mt-8 flex items-center gap-2 rounded-full bg-accent-blue/10 px-5 py-3 text-accent-blue">
          <Info className="w-5 h-5" />
          <span className="font-medium">Analyse sécurisée et anonyme</span>
        </div>
        <div className="mt-6 flex gap-2 text-center text-text-muted text-sm leading-relaxed px-4">
          <Lock className="w-4 h-4 mt-1 flex-shrink-0" />
          <p>Ne fermez pas l'application pendant que SENTINELLE inspecte chaque élément pour votre sécurité.</p>
        </div>
      </div>
    </div>
  );
}
